import React from "react";
import "./style.scss";
import m from "../../assets/images/meras/m.png";
import e from "../../assets/images/meras/e.png";
import r from "../../assets/images/meras/r.png";
import a from "../../assets/images/meras/a.png";
import s from "../../assets/images/meras/s.png";

const Loader = () => {
	const images = [m, e, r, a, s];

	return (
		<div className="loading-container">
			<div className="container">
				<div className="loading-text w-75 m-auto">
					{images.map((imgSrc, index) => (
						<img src={imgSrc} alt="meras" key={index} className="fade-in" />
					))}
				</div>
			</div>
		</div>
	);
};

export default Loader;
